const styles = theme => ({
    appBar: {
        position: 'relative',
        marginBottom: theme.spacing(1)
    },
    content: {
        marginTop: theme.spacing(1)
    },
    flex: {
        flex: 1,
    },
    gutter: {
        marginBottom: '20px'
    },
    sendHeader: {
        marginBottom: '20px'
    },
    radioGroup: {
        marginTop: '0'
    },
    codeField: {
        textAlign: 'center',
        marginTop: theme.spacing(1)
    },
    textFieldInput: {
        padding: 14
    },
    textLink: {
        textDecoration: 'underline',
        fontWeight: 600,
        color: theme.palette.text.secondary
    }
});

export default styles;